import produce from 'immer';
import { SET_CATEGORIES, MARK_MESSAGE_AS_READ, MARK_CATEGORY_AS_READ, RESTORE_CATEGORY_UNREAD_COUNT, SET_TEASERS_LOADING, SET_CATEGORIES_LOADING, SET_MARK_AS_READ_LOADING, SET_UNREAD_TOTAL } from './actions';
const initialState = {
    categories: null,
    unreadTotal: 0,
    loading: {
        teasers: false,
        categories: false,
        markingAsRead: false
    }
};
const communicationsReducer = (state = initialState, { type, payload }) => {
    return produce(state, draft => {
        switch (type) {
            case SET_CATEGORIES: {
                if (payload) {
                    draft.categories = new Map(payload.map(category => [category.id, category]));
                    draft.unreadTotal = payload.reduce((acc, category) => acc + (category.unreadMessagesCount || 0), 0);
                }
                break;
            }
            case SET_UNREAD_TOTAL: {
                draft.unreadTotal = payload;
                break;
            }
            case MARK_MESSAGE_AS_READ: {
                const category = draft.categories.get(payload);
                if (category && category.unreadMessagesCount > 0) {
                    category.unreadMessagesCount -= 1;
                    draft.unreadTotal = Math.max(0, draft.unreadTotal - 1);
                }
                break;
            }
            case MARK_CATEGORY_AS_READ: {
                const category = draft.categories.get(payload);
                if (category) {
                    const previousUnread = category.unreadMessagesCount || 0;
                    category.unreadMessagesCount = 0;
                    draft.unreadTotal = Math.max(0, draft.unreadTotal - previousUnread);
                }
                break;
            }
            case RESTORE_CATEGORY_UNREAD_COUNT: {
                const category = draft.categories.get(payload.categoryId);
                if (category) {
                    const currentUnread = category.unreadMessagesCount || 0;
                    const difference = payload.count - currentUnread;
                    category.unreadMessagesCount = payload.count;
                    draft.unreadTotal = Math.max(0, draft.unreadTotal + difference);
                }
                break;
            }
            case SET_TEASERS_LOADING: {
                draft.loading.teasers = payload;
                break;
            }
            case SET_CATEGORIES_LOADING: {
                draft.loading.categories = payload;
                break;
            }
            case SET_MARK_AS_READ_LOADING: {
                draft.loading.markingAsRead = payload;
                break;
            }
        }
    });
};
export default communicationsReducer;
